module.exports = __webpack_public_path__ + "media/npc_dota_hero_riki.8c6cbecf.webm";